export function isSettingsAiProvider(value) {
    return value === 'openai-codex' || value === 'gemini' || value === 'opencode-go';
}
export function isSlackReplyTone(value) {
    return value === 'professional' || value === 'casual' || value === 'direct' || value === 'warm';
}
/** Default empty Jira connection for new users. */
export function defaultJiraConnectionSettings() {
    return {
        baseUrl: '',
        email: '',
        authMethod: 'none',
        oauthConnected: false,
        oauthSiteName: '',
    };
}
/**
 * Degraded model lists, used only when a provider's models endpoint cannot be
 * read (see `apps/api/src/aiModelCatalog.ts`). The live catalog is the source
 * of truth — `deepseek-chat` sat in this list long after OpenCode Go retired
 * it, which is why Settings now asks the provider instead.
 */
export const OPENCODE_GO_MODEL_OPTIONS = [
    'deepseek-v4-flash',
    'deepseek-v4-pro',
    'glm-5.3-flash',
    'kimi-k3',
];
export const GEMINI_MODEL_OPTIONS = ['gemini-2.5-flash', 'gemini-2.5-pro'];
/** Codex is OAuth-only and publishes no models endpoint — this list is it. */
export const OPENAI_CODEX_MODEL_OPTIONS = ['gpt-5-codex', 'gpt-5'];
export const STATIC_AI_MODEL_OPTIONS = {
    'opencode-go': OPENCODE_GO_MODEL_OPTIONS,
    gemini: GEMINI_MODEL_OPTIONS,
    'openai-codex': OPENAI_CODEX_MODEL_OPTIONS,
};
/** Default model when the user has not chosen one. */
export const DEFAULT_SETTINGS_AI_MODEL = 'deepseek-v4-flash';
/** Default AI generation settings for new users. */
export function defaultAiGenerationSettings() {
    return { provider: 'opencode-go', model: DEFAULT_SETTINGS_AI_MODEL };
}
/** Default Slack voice settings for new users. */
export function defaultSlackVoiceSettings() {
    return {
        language: 'es',
        tone: 'professional',
        replyLength: 'medium',
        customPrompt: '',
    };
}
/** Max words for a reply length preference. */
export function slackReplyLengthMaxWords(length) {
    if (length === 'short')
        return 60;
    if (length === 'long')
        return 220;
    return 120;
}
/** Build a SecretStatus from a stored secret string (never returns the secret). */
export function secretStatusFromValue(value) {
    const trimmed = typeof value === 'string' ? value.trim() : '';
    if (!trimmed)
        return { configured: false, lastFour: null };
    return {
        configured: true,
        lastFour: trimmed.length <= 4 ? trimmed : trimmed.slice(-4),
    };
}
//# sourceMappingURL=settings.js.map